import { FormControl, InputLabel, Select, FormHelperText } from '@mui/material'
import { Controller } from 'react-hook-form'
import { MenuItem } from '@mui/material'

export const InputDropdownGroup = ({
  name,
  control,
  label,
  required = false,
  options,
  noMargin = false,
  setValue = null,
}) => {
  return (
    <Controller
      rules={{ required: required ? 'Ce champ est obligatoire' : false }}
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <FormControl error={!!error} sx={noMargin ? { mb: 0 } : { mb: 3 }}>
            <InputLabel>{label}</InputLabel>
            <Select
              onChange={(e) => {
                if (setValue) setValue(e.target.value)
                onChange(e.target.value)
              }}
              value={value}
              label={label}
            >
              {options.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.value}>
                    {option.label}
                  </MenuItem>
                )
              })}
            </Select>
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )
      }}
    />
  )
}
